import { FeeScheduleControllerApi } from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

/**
 *
 * @author Rajkumar Rathod
 */
export const useFeeScheduleArchive = () =>
  useMutationWithLoading(
    async (params: {
      feeScheduleId: string;
      status: boolean;
      xTENANTID?: string;
    }) =>
      new FeeScheduleControllerApi(
        getConfigObject()
      ).updateFeeScheduleArchiveStatus(
        params?.feeScheduleId,
        params?.status,
        params?.xTENANTID
      )
  );
